import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'

const LoanDetailBasicUI = ({ loan, onAmountUpdateClick, onUpdateDepositClick, onWaivePromoterfundClick }) =>
  <CardUI className='g_m_top_100'>
    <table className='g_small'><tbody>
      {
        loan.status === 'term_sheet' &&
        <tr>
          <td>A</td>
          <td>Termsheet amount</td>
          <td>{loan.termSheet.amountF2}</td>
        </tr>
      }
      {
        (loan.status === 'sanctioned' || loan.status === 'disbursed') &&
        <tr>
          <td>A</td>
          <td>Loan amount</td>
          <td className='g_text_right'>{loan.sanction.amountF2}</td>
        </tr>
      }
      <tr>
        <td>B</td>
        <td>
          Processing fee
        </td>
        <td className='g_text_right'>
          {
            loan.termSheet.processingFee1.amountWithoutTax !== 0 &&
            <span>{loan.termSheet.processingFee1.amountWithTaxF2} + </span>
          }
          <span>{loan.termSheet.processingFee2.amountWithTaxF2}</span>
        </td>
        <td />
        <td className='g_small'>{loan.termSheet.processingFeePercentF} of A + GST</td>
      </tr>
      <tr>
        <td>C</td>
        <td>DSRA</td>
        <td className='g_text_right'>
          {loan.sanction.dsraAmountF2}
          {
            loan.termSheet.dsraFromLoan &&
            <BadgeUI label='from disbursement' />
          }
        </td>
        <td>
          <span className="icon icon-pencil g_m_right_100 g_muted" onClick={onUpdateDepositClick}></span>
        </td>
        <td />
        {
          loan.sanction.dsraPercent != 0 &&
          <td className='g_small'>{loan.sanction.dsraPercent}% of A</td>
        }
      </tr>
      {/*
      <tr>
        <td></td>
        <td>Security deposit</td>
        <td className='g_text_right'>{loan.sanction.depositAmountF2}</td>
        <td/>
        {
          loan.sanction.depositPercent !== null &&
          <td className='g_small'>{loan.sanction.depositPercent}% of A</td>
        }
      </tr>
      */}
      <tr>
        <td>D</td>
        <td>Promoter contribution</td>
        <td className='g_text_right'>{loan.sanction.promoterFundF2}</td>
        <td>
          <span className="icon icon-pencil g_m_right_100 g_muted" onClick={onWaivePromoterfundClick}></span>
        </td>
        <td className='g_small'>
          Typically project cost - loan amount + processing fee + DSRA + security deposit
        </td>
      </tr>

      <tr>
        <td>E</td>
        <td className='g_no_wrap_2'>Expected Use of Proceeds</td>
        <td className='g_text_right1'>{loan.sanction.useOfProceedsF2}</td>
        <td>
          <span className="icon icon-pencil g_m_right_100 g_muted" onClick={onAmountUpdateClick}></span>
        </td>
        <td className='g_small'>= A-B-C+D</td>
      </tr>

      <tr>
        <td></td>
        <td>Fixed Bucket</td>
        <td className='g_text_right'>{loan.sanction.fixedBucketF2}</td>
        <td />
        <td className='g_small'>Fixed utilisation against predefined expenditure (90% of E)</td>
      </tr>
      <tr>
        <td></td>
        <td>Contingent Bucket</td>
        <td className='g_text_right'>{loan.sanction.contingentBucketF2}</td>
        <td />
        <td className='g_small'>Contingency payments freely used by borrower (10% of E)</td>
      </tr>

      <tr>
        <td></td>
        <td>Expected Bank Balance</td>
        <td className='g_text_right'>{loan.sanction.expectedBankBalanceF2}</td>
        <td />
        <td className='g_small'>Expected balance before disbursement (D)</td>
      </tr>
    </tbody></table>
  </CardUI>


export default LoanDetailBasicUI
